"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
require("./item.scss");
const core_1 = require("@material-ui/core");
const common_1 = require("../../../../../utils/common");
const chatSlice_1 = require("../../../../../redux/slices/chatSlice");
const avatar_1 = __importDefault(require("../../avatar/avatar"));
const _ = __importStar(require("lodash"));
const caseInfo = (caseData, items) => {
    return react_1.default.createElement(core_1.Grid, { item: true, md: 7, className: "case-info" }, items.map((val, key) => {
        let result = '';
        result = val.multiple ? `${_.get(caseData, val.key[0])}, ${_.get(caseData, val.key[1])}` : _.get(caseData, val.key);
        if (val.key === 'date' || val.key === 'deadline') {
            result = `${val.key === 'date' ? 'Date' : 'Deadline'}: ${moment_1.default(result).utc().format('MMM D, h:mm a').toUpperCase()}`;
        }
        else if ((result === null || result === void 0 ? void 0 : result.toLowerCase().indexOf('add manually')) > -1) {
            result = _.get(caseData, 'fullAddress');
        }
        return (react_1.default.createElement("p", { key: key, className: `${val.className}` }, result));
    }));
};
const Item = (props) => {
    var _a, _b;
    const lastMsg = JSON.parse(props.item.body);
    const unread = lastMsg.unreadCount && lastMsg.latestWriter !== props.user.id && lastMsg.status === '0' ? lastMsg.unreadCount : 0;
    const caseData = props.item.case;
    const setActiveChat = (chat) => {
        window.AppearMe.Widgets.Events.emit('onChatSelect', chat);
        props.selectChat(chat);
    };
    // get case info by its type
    const getCaseInfo = () => {
        let item;
        if (props.item.cr_id) {
            item = caseInfo(caseData, common_1.LIST_GENERIC_TYPES.cr);
        }
        else if (props.item.tr_id) {
            item = caseInfo(caseData, common_1.LIST_GENERIC_TYPES.tr);
        }
        else if (props.item.fatt_id) {
            item = caseInfo(caseData, common_1.LIST_GENERIC_TYPES.fatt);
        }
        else if (props.item.rc_id) {
            item = caseInfo(caseData, common_1.LIST_GENERIC_TYPES.rc);
        }
        else {
            item = caseInfo(caseData, caseData.appearanceType === 'Deposition' ? common_1.LIST_GENERIC_TYPES.depo : common_1.LIST_GENERIC_TYPES.case);
        }
        return item;
    };
    let userLink;
    if (props.item.tr_id) {
        userLink = `tr-profile?id=${props.item.sender.id}`;
    }
    else if (props.item.cr_id) {
        userLink = `profile?id=${props.item.sender.id}`;
    }
    else {
        userLink = `profile-guest?id=${props.item.sender.id}`;
    }
    let caseStatus;
    if (props.item.fatt_id) {
        caseStatus = common_1.CASE_STATUSES['fatt'][caseData.status];
    }
    else if (props.item.tr_id) {
        caseStatus = common_1.CASE_STATUSES['tr'][caseData.status];
    }
    else if (props.item.cr_id) {
        caseStatus = common_1.CASE_STATUSES['cr'][caseData.status];
    }
    else {
        caseStatus = common_1.getCaseStatus(caseData.status);
    }
    return (react_1.default.createElement(core_1.Grid, { container: true, onClick: () => setActiveChat(props.item), className: "list-item d-flex justify-content-between" },
        react_1.default.createElement(core_1.Grid, { item: true, md: 3, className: "user-info d-flex" },
            react_1.default.createElement(avatar_1.default, { imageUrl: (_a = props.item.sender) === null || _a === void 0 ? void 0 : _a.imageUrl, unread: unread }),
            react_1.default.createElement(core_1.Box, { className: 'info-block', display: 'flex', flexDirection: 'column' },
                react_1.default.createElement("a", { className: 'text user-info-name' }, (_b = props.item.sender) === null || _b === void 0 ? void 0 : _b.name),
                react_1.default.createElement(core_1.Hidden, { mdUp: true },
                    caseData.deadline &&
                        react_1.default.createElement("p", { className: "text text-date" }, moment_1.default(caseData.deadline).utc().format('MMM D, h:mm A').toUpperCase()),
                    caseData.date &&
                        react_1.default.createElement("p", { className: "text text-date" }, moment_1.default(caseData.date).utc().format('MMM D, h:mm A').toUpperCase()),
                    caseData.genericType && react_1.default.createElement("p", { className: "text" }, caseData.genericType)))),
        react_1.default.createElement(core_1.Hidden, { smDown: true }, getCaseInfo()),
        react_1.default.createElement(core_1.Grid, { item: true, md: 2, className: "case-status-wrapper" },
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement("p", { className: `status ${caseStatus.className}` }, caseStatus.name),
                react_1.default.createElement("p", { className: 'date' }, moment_1.default(props.item.updatedAt).format('MM/DD/YYYY'))),
            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                react_1.default.createElement(core_1.Box, { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', className: 'h-100' },
                    react_1.default.createElement("div", { className: `${caseStatus.className}-mobile` }),
                    react_1.default.createElement("p", { className: 'date' }, moment_1.default(props.item.updatedAt).format('MM/DD/YYYY')))))));
};
const mapStateToProps = (state) => {
    const { user } = state;
    return {
        user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        selectChat: (data) => dispatch(chatSlice_1.selectChat(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Item);
